<script setup>
import CLink from "@/Components/CLink.vue";
import { ref } from "vue";

import CCardProductItem from "@/Components/CCardProductItem.vue";

const props = defineProps({
    highlightsProducts: Object,
    canViewPrices: Boolean,
    canViewStock: Boolean,
})

const page = ref(1)

</script>

<template>
    <v-sheet class="justify-center mx-auto w-75 mb-15 stack-container">
        <div class="pa-4">
            <h1 class="text-center pb-3">Conheça nossos produtos em destaque</h1>
            <h2 class="text-center pb-4 font-weight-medium">Explore nossos produtos em destaque e descubra as soluções que mais combinam com você — além dos outros 5 mil itens disponíveis em nossas diversas categorias, reunindo tecnologia, qualidade e estilo para elevar sua experiência.</h2>
        </div>
        <v-data-iterator
            :items="props.highlightsProducts"
            items-per-page="8"
            :page="page"
        >
            <template v-slot:default="{ items }">
                <v-row class="stack-grid">
                    <v-col cols="12" sm="6" md="4" lg="3" xl="3"
                           v-for="(product, index) in items"
                           :key="product.raw.reference"
                           :style="{ zIndex: 100 - index, position: 'relative', overflow: 'visible' }">
                        <c-card-product-item :product='product.raw' :can-view-price="canViewPrices" :can-view-stock="canViewStock"/>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:footer="{ page, pageCount, prevPage, nextPage }">
                <v-row>
                    <v-col>
                        <div class="d-flex align-center mt-3 float-left">
                            <v-btn
                                :disabled="page === 1"
                                density="comfortable"
                                icon="mdi-arrow-left"
                                variant="elevated"
                                color="primary"
                                @click="prevPage"
                            ></v-btn>

                            <div class="mx-2 text-caption">
                                Pagina {{ page }} de {{ pageCount }}
                            </div>

                            <v-btn
                                :disabled="page >= pageCount"
                                density="comfortable"
                                icon="mdi-arrow-right"
                                variant="elevated"
                                color="primary"
                                @click="nextPage"
                            ></v-btn>
                        </div>
                        <div class="d-flex align-center mt-3 justify-end mr-0">
                            <c-link :href="route('product.list', {'filters':'destaque'})">
                                <v-btn color="primary" variant="elevated">Ver todos os destaques</v-btn>
                            </c-link>
                        </div>
                    </v-col>
                </v-row>
            </template>
        </v-data-iterator>
    </v-sheet>
</template>
<style scoped>
.stack-container {
    position: relative;
    overflow: visible;
}
.stack-grid {
    position: relative;
    overflow: visible;
}
.stack-grid > .v-col {
    position: relative;
    overflow: visible;
}
/* Ensure earlier items (upper row) paint above later ones */
.stack-grid > .v-col:nth-child(1) { z-index: 60; }
.stack-grid > .v-col:nth-child(2) { z-index: 59; }
.stack-grid > .v-col:nth-child(3) { z-index: 58; }
.stack-grid > .v-col:nth-child(4) { z-index: 57; }
.stack-grid > .v-col:nth-child(5) { z-index: 56; }
.stack-grid > .v-col:nth-child(6) { z-index: 55; }
.stack-grid > .v-col:nth-child(7) { z-index: 54; }
.stack-grid > .v-col:nth-child(8) { z-index: 53; }
</style>